import { useAddToCart as useAddToCartCore } from '@ztechapps/order.common'
import { useUser } from './useUser'
import { routesDef } from '../config/routes'
import React from 'react'
import { useAlertDialog, useError, useHistory } from '@ztechapps/common.hook'
import { useOrderCartCount } from './useOrderCartCount'
import type { Product } from '@ztechapps/common.contract'
import type { PartialDeep } from 'type-fest'

export const useAddToCart = ({ quantity, product }: { quantity: number; product: PartialDeep<Product> }) => {
  const history = useHistory()

  const { onError } = useError()

  const { addToCart, loading, error } = useAddToCartCore()

  const orderGetCartResult = useOrderCartCount()

  const [fakeLoading, setFakeLoading] = React.useState(false)
  const { loggedIn } = useUser()
  const { alert } = useAlertDialog({
    text: 'You need to login first before adding item to your cart.',
    title: 'Login first!',
  })

  const onClick = async (e) => {
    setFakeLoading(true)
    e?.preventDefault()

    if (loading) return

    if (!loggedIn) {
      await alert()
      return history.push(routesDef.LoginPage.altPath())
    }

    try {
      await addToCart({ quantity, product })

      if (!orderGetCartResult?._id) {
        await orderGetCartResult?.refetch?.()
      }
    } catch (error) {
      onError(error)
    } finally {
      setFakeLoading(false)
    }
  }

  const finalLoading = loading || fakeLoading
  const icon = finalLoading ? 'fas fa-spinner fa-spin' : 'fa fa-cart-arrow-down'
  const text = finalLoading ? 'Adding...' : 'Add to cart'

  return { addToCart: onClick, error, loading: finalLoading, icon, text }
}
